var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggles"
  }, _vm._l((_vm.options), function(option, idx) {
    return _c('div', {
      staticClass: "toggle"
    }, [_c('input', {
      key: option.value,
      attrs: {
        "id": option.value,
        "type": "radio",
        "name": _vm.radioGroupID
      },
      domProps: {
        "checked": option.value === _vm.value,
        "value": option.value
      },
      on: {
        "change": function($event) {
          _vm.$emit('change', $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      key: ((option.value) + "-label"),
      staticClass: "cm-button",
      attrs: {
        "for": option.value
      }
    }, [_vm._v(_vm._s(option.label))])])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5506aeec","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/toggle.vue
// module id = null
// module chunks = 